import classnames from "classnames"
import If from "@mobi/components/If"
import Checkbox from "@mobi/ds/components/Checkbox"
import Radio from "@mobi/ds/components/Radio"
import { IChipProps } from "../types"
import "./Chip.scss"

const Chip = ({
  isDisabled,
  id,
  label,
  name,
  type,
  value,
  control,
  clickCallback,
  modifier
}: IChipProps) => {
  const chipBaseClass = "ds-chip"
  const ChipClasses = classnames(chipBaseClass, {
    "ds-chip--disabled": isDisabled,
    [`ds-chip--${modifier}`]: modifier
  })

  const handleRadioClick = (option) => {
    clickCallback?.({
      option,
    })
  }

  return (
    <>
      <div className={ChipClasses}>
        {control && (
          <If
            condition={type === "radio"}
            renderIf={
              <Radio
                control={control}
                id={id}
                isDisabled={isDisabled}
                name={name}
                value={value}
                onClick={() => handleRadioClick(value)}
              >
                <span role="radio" aria-label={`${label}`}>
                  {label}
                </span>
              </Radio>
            }
            renderElse={
              <Checkbox
                control={control}
                isDisabled={isDisabled}
                label={label}
                name={name}
              />
            }
          />
        )}
      </div>
    </>
  )
}

export default Chip
